import { createSelector } from '@ngrx/store';
import { AppState } from '../../../core/models/appState.model';
import { LPGFuelGasFlaringReportDTO } from 'src/app/web-api-client';

export const FuelGasFlaringSelector = createSelector(
  (state: AppState) => state.fuelGasFlaring.data,
  (list: LPGFuelGasFlaringReportDTO | null) => list
);
